import { useQuery } from '@tanstack/react-query'

import { currentYearMonthKst } from '@/lib/venue/dashboardViewModel'
import { fetchReservationRefundSummary } from '@/lib/venue/reservationRefundApi'
import type { ReservationRefundSummaryView } from '@/lib/venue/reservationRefundTypes'

export function reservationRefundSummaryQueryKey(venueId: string, yearMonth: string) {
  return ['venue', venueId, 'reservation-refunds', 'summary', yearMonth] as const
}

/**
 * 이번 달(KST) 취소·환불 요약(#589) — 대시보드의 "2차 보강" 데이터다.
 * 🚨 이 쿼리가 실패해도 `VenueDashboardPage` 는 나머지 섹션을 그대로 렌더한다(설계 §2-1(f)).
 */
export function useReservationRefundSummary(venueId: string) {
  const yearMonth = currentYearMonthKst()
  return useQuery<ReservationRefundSummaryView>({
    queryKey: reservationRefundSummaryQueryKey(venueId, yearMonth),
    queryFn: () => fetchReservationRefundSummary(venueId, yearMonth),
  })
}
